// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconCommonBack_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M1.41421 7.58403L6.78677 2.20215L8.20221 3.61759L3.82843 7.99896L17.5 8.00107L17.5 7.99975C21.0898 7.99975 24 10.9099 24 14.4998C24 18.0896 21.0898 20.9998 17.5 20.9998L9 20.9997V18.9997L17.5 18.9998C19.9853 18.9998 22 16.985 22 14.4998C22 12.0145 19.9853 9.99975 17.5 9.99975L17.5 10.0024L3.82843 10.0024L8.20273 14.3843L6.7873 15.7998L1.41421 10.4174L0 9.0007L1.41421 7.58403Z" class="svg-bg"/>
</svg>
`;
/**
 * IconCommonBack is a generated icon component.
 */
let IconCommonBack = IconCommonBack_1 = class IconCommonBack extends IconBaseElement {
    render() {
        return html `${IconCommonBack_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconCommonBack.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconCommonBack = IconCommonBack_1 = __decorate([
    customElement('zui-icon-common-back')
], IconCommonBack);
export { IconCommonBack };
